export const GET_SUBSCRIPTIONS_HISTORY = 'GET_SUBSCRIPTIONS_HISTORY'
export const SET_SUBSCRIPTIONS_HISTORY = 'SET_SUBSCRIPTIONS_HISTORY'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'
export const GET_SUBSCRIPTION_INVOICES = 'GET_SUBSCRIPTION_INVOICES'
export const SET_SUBSCRIPTION_INVOICES = 'SET_SUBSCRIPTION_INVOICES'
export const GET_SUBSCRIPTION_RECEIPTS = 'GET_SUBSCRIPTION_RECEIPTS'
export const SET_SUBSCRIPTION_RECEIPTS = 'SET_SUBSCRIPTION_RECEIPTS'
export const PAY_INVOICE = 'PAY_INVOICE'
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE'
export const DOWNLOAD_RECEIPT = 'DOWNLOAD_RECEIPT'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'
export const ASSIGN_PARKER = 'ASSIGN_PARKER'
export const REMOVE_PARKER = 'REMOVE_PARKER'
export const SAVE_PAD_DATA = 'SAVE_PAD_DATA'
export const GET_WAIT_LIST = 'GET_WAIT_LIST'
export const SET_WAIT_LIST = 'SET_WAIT_LIST'
export const DELETE_WAIT_LIST_ITEM = 'DELETE_WAIT_LIST_ITEM'

export const SUBSCRIPTION_STATUS_ACTIVE = 'ACTIVE'
export const SUBSCRIPTION_STATUS_CANCELLED = 'CANCELED'
export const SUBSCRIPTION_STATUS_WAITING = 'WAITING'
export const SUBSCRIPTION_STATUSES = [
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_CANCELLED,
    SUBSCRIPTION_STATUS_WAITING,
]

export const ADDRESS_TYPE_BILLING = 'BILLING'
export const ADDRESS_TYPE_SHIPPING = 'SHIPPING'
export const CONTACT_TYPE_BILLING = 'BILLING'
export const CONTACT_TYPE_SHIPPING = 'OTHER'

export const PAYMENT_METHOD_TYPE = 'ELECTRONIC'

export const INVOICE_TYPE_POSTED = 'Posted'

export const SUBSCRIPTION_MODAL_TAB_BILLING = 0
export const SUBSCRIPTION_MODAL_TAB_PRODUCTS = 1
export const SUBSCRIPTION_MODAL_TAB_INVOICES = 2
export const SUBSCRIPTION_MODAL_TAB_RECEIPTS = 3

export const INVOICE_PAYMENT_PROGRESS = 'invoicePayment'
export const UPDATE_SUBSCRIPTION_PROGRESS = 'updateSubscription'
export const ASSIGN_PARKER_PROGRESS = 'assignParker'
export const REMOVE_PARKER_PROGRESS = 'removeParker'
export const SAVE_PAD_DATA_PROGRESS = 'setPadData'

export const WAIT_LIST_PENDING = 'PENDING'
export const WAIT_LIST_REQUESTED = 'REQUESTED'

export const SUBSCRIPTION_CREDENTIAL_TYPE_MAIL = 'MAIL'
export const SUBSCRIPTION_CREDENTIAL_TYPE_EXPMAIL = 'EXPMAIL'
export const SUBSCRIPTION_CREDENTIAL_TYPE_LOCATION = 'LOCATION'
